import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import apiCus from '../../services/service_customer'
import Swal from 'sweetalert2'
import moment from 'moment'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      cus_age: 0,
      last_date: new Date(),
      title: 'จัดการข้อมูลลูกหนี้',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_active: false,
      modal_data: {
        id: 0,
        code: '',
        tax_id: '',
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        gender_id: null,
        birth_date: '',
        facebook: '',
        line_id: '',
        active_status: 1
      },
      modal_title: '',
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      }
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.data_list.filter(customer => {
        return (
          customer.name.indexOf(text) > -1 || customer.code.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    editCus (data) {
      this.modal_title = 'แก้ไขข้อมูลลูกหนี้'
      this.modal_active = true
      this.modal_data = data
      this.modal_data.birth_date = moment(data.birth_date)
      // console.log(moment(this.last_date).format('YYYY'))
      // console.log(moment(data.birth_date).format('YYYY'))
      this.cus_age = moment(this.last_date).format('YYYY') - moment(data.birth_date).format('YYYY')
    },
    newCus () {
      this.modal_data = {
        id: 0,
        code: '',
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        gender_id: null,
        birth_date: '',
        face_book: '',
        line_id: '',
        active_status: 1
      }
      this.modal_active = true
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        id: 0,
        code: '',
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        gender_id: null,
        birth_date: '',
        face_book: '',
        line_id: '',
        active_status: 1
      }
    },
    getAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiCus.listAll(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    removeCus (code) {
      Swal.fire({
        title: 'ลบข้อมูลลูกหนี้',
        text: 'ท่านต้องการลบข้อมูลลูกหนี้รหัส ' + code + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'code': code,
            'active_status': 0
          }
          apiCus.removeCus(this.REST_URL,
            this.header,
            body,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.$notification['success']({
                  message: 'ลบข้อมูลลูกหนี้',
                  description:
                    result.message
                })
              } else {
                this.$notification['warning']({
                  message: 'ดึงข้อมูลลูกหนี้',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        }
      })
    },
    action_modal () {
      if (this.modal_data.id === 0) {
        this.addCus()
      } else {
        this.updateCus()
      }
    },
    addCus () {
      this.$store.commit('Loading')
      this.modal_data.birth_date = moment(this.modal_data.birth_date).format('YYYY-MM-DD')
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = parseInt(this.modal_data.debt_limit)
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      apiCus.AddCus(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'เพิ่มข้อมูลลูกหนี้',
              description:
                      result.message
            })
          } else {
            this.$notification['error']({
              message: 'เพิ่มข้อมูลลูกหนี้',
              description:
                      result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    updateCus () {
      this.$store.commit('Loading')
      this.modal_data.birth_date = moment(this.modal_data.birth_date).format('YYYY-MM-DD')
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = parseInt(this.modal_data.debt_limit)
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      apiCus.UpdateCus(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'บันทึกข้อมูลลูกหนี้',
              description:
                      result.message
            })
          } else {
            this.$notification['error']({
              message: 'บันทึกข้อมูลลูกหนี้',
              description:
                      result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/customer.js